import React from 'react';

export const LabeledInput = ({
    label,
    onChange,
    className,
    value,
    type,
    required
}) => (
    <div className={className}>
        <span className={'input-label'}>{label}</span>
        <input
            type={type || 'text'}
            required={required}
            onChange={({ target }) => onChange(target.value)}
            value={value || ''}
        />
    </div>
);
